import ResizeObserver from 'resize-observer-polyfill';

class PinnedElementDirective {
    constructor($window, $rootScope) {
        this.restrict = 'A';
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.controllerAs = '$ctrl';
        this.scope = {};
        this.hasDummyElement = false;
        this.previousSize = null;
        this.previousY = null;
        this.debug = false;
    }

    link(scope, element, attrs) {
        this.element = element;
        this.position = 'static';
        this.relativeElement = angular.element(document.getElementById(attrs.pinnedElement));
        this.parentElement = this.element.parent().parent().parent();
        this.dummyElement = angular.element('<div></div>');
        this.element.css('top', 0).css('left', 0).css('right', 0).css('transition', 'all .2s');
        this.parentElement.css('overflow', 'hidden');
        this.timeout = null;
        this.positionSet = false;

        window.addEventListener('resize', () => {
            this.onResize();
        });

        this.setSizes();
        this.calculateElementPositionTimeout('link');

        const observer = new MutationObserver((mutations, observer) => {
            this.refresh();
        });

        observer.observe(document.getElementById('products-list'), {
            subtree: true,
            childList: true
        });

        const elementResizeObserver = new ResizeObserver((entries, observer) => {
            this.calculateElementPositionTimeout('resizeObserver');
        });

        elementResizeObserver.observe(this.element[0]);

        document.addEventListener('scroll', (e) => {
            this.calculateElementPositionTimeout('scroll');
        });
    }

    calculateElementPositionTimeout(msg) {
        if (this.debug) {
            console.log('calculateElementPositionTimeout', msg)
        }

        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        this.timeout = setTimeout(() => {
            this.calculateElementPosition();
        }, 100);
    }

    isMobile() {
        return window.innerWidth < 992;
    }

    onResize() {
        this.updateParentElementHeight();
        this.calculateElementPositionTimeout('onResize');
    }

    refresh() {
        this.updateParentElementHeight();
        this.calculateElementPositionTimeout('refresh mutation');
    }

    setSizes() {
        this.elementBBox = this.element[0].getBoundingClientRect();
        this.dummyElement.css('width', this.elementBBox.width + 'px');
        this.dummyElement.css('height', this.elementBBox.height + 'px');
        this.pinTo = this.elementBBox.height > window.innerHeight ? 'bottom' : 'top';
    }

    calculateElementPosition() {

        if (this.relativeElement[0].getBoundingClientRect().height < window.innerHeight) {
            return;
        }

        if (this.relativeElement[0].getBoundingClientRect().height - this.element[0].getBoundingClientRect().height < 200) {
            return;
        }

        if (this.isMobile()) {
            this.element.css('position', 'static');
            return;
        }

        this.element.css('position', 'absolute');

        this.insertDummyElement();

        let direction = 0;

        const UP = -1;
        const DOWN = 1;
        const CONSTANT = 0;

        if (this.previousY) {
            direction = this.previousY && window.scrollY > this.previousY ? DOWN : UP;
        }

        this.previousY = window.scrollY;
        let headerHeight = window.innerWidth >= 1450 ? 120 : 200;
        let isBiggerThanWindow = this.element[0].getBoundingClientRect().height > window.innerHeight - headerHeight;

        switch (isBiggerThanWindow) {
            case true:
                let elementBottomBelowWindow = this.element[0].getBoundingClientRect().bottom - window.innerHeight;
                let elementAboveWindow = this.element[0].getBoundingClientRect().top - headerHeight;

                if (this.debug) {
                    console.log('elementBottomBelowWindow', elementBottomBelowWindow);
                    console.log('elementAboveWindow', elementAboveWindow, this.element[0].getBoundingClientRect().top);
                    console.log('direction', direction === UP ? 'up' : 'down', direction);
                    console.log('isBiggerThanWindow', isBiggerThanWindow);
                }

                if (this.parentElement[0].getBoundingClientRect().top > 0) {
                    // Element na górze rodzica
                    this.element.css('position', 'absolute').css('top', 0);
                } else if (this.parentElement[0].getBoundingClientRect().bottom - window.innerHeight < 0 && this.parentElement[0].getBoundingClientRect().height - this.element[0].getBoundingClientRect().height > 0) {
                    // Element dotarł do dołu rodzica
                    this.element.css('position', 'absolute').css('top', (this.parentElement[0].getBoundingClientRect().height - this.element[0].getBoundingClientRect().height) + 'px');
                    this.positionSet = true;
                } else if (elementBottomBelowWindow < 0 && (direction === DOWN || direction === CONSTANT)) {
                    // Element znalazł się za wysoko - przesuń w dół
                    this.element.css('position', 'absolute').css('top', -(this.parentElement[0].getBoundingClientRect().top + this.element[0].getBoundingClientRect().height - window.innerHeight) + 'px');
                    this.positionSet = true;
                } else if ((direction === UP && elementAboveWindow > 0 || !this.positionSet) && this.parentElement[0].getBoundingClientRect().top - headerHeight < 0) {
                    // Element znalazł się za nisko - przesuń w górę
                    this.element.css('position', 'absolute').css('top', (-this.parentElement[0].getBoundingClientRect().top + headerHeight) + 'px');
                    this.positionSet = true;
                }
                break;
            case false:
                let elementOnTheBottom = window.innerHeight - this.element[0].getBoundingClientRect().height - headerHeight < window.innerHeight - this.parentElement[0].getBoundingClientRect().bottom;

                if (this.debug) {
                    console.log('parentBottom', this.parentElement[0].getBoundingClientRect().bottom);
                    console.log('windowHeight', window.innerHeight);
                    console.log('elementHeight', this.element[0].getBoundingClientRect().height);
                    console.log('headerHeight', headerHeight);
                }

                if (this.parentElement[0].getBoundingClientRect().top > 0) {
                    // Element na górze rodzica
                    this.element.css('position', 'absolute').css('top', 0);
                } else if (elementOnTheBottom) {
                    // Element dotarł do dołu rodzica
                    this.element.css('position', 'absolute').css('top', (this.parentElement[0].getBoundingClientRect().height - this.element[0].getBoundingClientRect().height) + 'px');
                    this.positionSet = true;
                } else {
                    // Element znalazł się za nisko - przesuń w górę
                    this.element.css('position', 'absolute').css('top', (-this.parentElement[0].getBoundingClientRect().top + headerHeight) + 'px');
                    this.positionSet = true;
                }
                break;
        }
    }

    insertDummyElement() {
        this.updateParentElementHeight();
    }

    updateParentElementHeight() {
        if (this.isMobile()) {
            this.parentElement.css('height', 'auto');
            this.parentElement.css('min-height', null);
        } else {
            this.parentElement.css('min-height', this.element[0].getBoundingClientRect().height + 'px');
        }
    }

    removeDummyElement() {
        if (!this.hasDummyElement) {
            return;
        }
        this.hasDummyElement = false;
        this.dummyElement.detach();
    }

    static directiveFactory($compile, $timeout, $rootScope) {
        'ngInject';
        return new PinnedElementDirective($compile, $timeout, $rootScope);
    }
}

export default PinnedElementDirective;
